export const OWNER = 'owner'
export const ASSISTANT = 'assistant'
export const CHILD_STORE = 'childStore'
